export const assistantPrimaryButtonSx = {
  borderRadius: '8px',
  px: 1.6,
  minHeight: 32,
  textTransform: 'none',
  fontWeight: 600,
  lineHeight: 1.4,
  whiteSpace: 'normal',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
};

export const assistantSecondaryButtonSx = {
  borderRadius: '8px',
  px: 1.45,
  minHeight: 32,
  textTransform: 'none',
  fontWeight: 600,
  lineHeight: 1.4,
  whiteSpace: 'normal',
  borderColor: 'divider',
  color: 'text.primary',
  bgcolor: 'background.paper',
  '&:hover': {
    borderColor: 'rgba(15, 23, 42, 0.24)',
    bgcolor: 'action.hover',
  },
};

export const assistantTextButtonSx = {
  borderRadius: '8px',
  px: 1.25,
  minHeight: 32,
  textTransform: 'none',
  fontWeight: 600,
  lineHeight: 1.4,
  whiteSpace: 'normal',
  color: 'text.secondary',
  '&:hover': {
    bgcolor: 'rgba(15, 23, 42, 0.045)',
    color: 'text.primary',
  },
};
